import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { routerPath } from 'src/Config';
import { MessagingActions } from 'src/Redux';
import { IconLetter } from 'src/Assets/svg/Letter';
import { Badge } from 'src/shared';
import { i18, trb } from 'src/Utilities';

export const UserMessages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { MessagesCount, sendMessagesCountInitial } = useSelector((state) => state.MessagingReducers);

  useEffect(() => {
    const fetchMessages = () => {
      dispatch(MessagingActions.getNewMessagesCount());
    };

    fetchMessages();

    const interval = setInterval(fetchMessages, 30000);

    return () => clearInterval(interval);
  }, [dispatch]);

  const gotoMessage = () => {
    if (MessagesCount.CountBroadCast > 0) {
      navigate(`${routerPath.messages}/${routerPath.messagesBroadCast}`); //
    } else if (MessagesCount.CountChat > 0) {
      navigate(`${routerPath.messages}/${routerPath.messagesInbox}`);
    } else {
      navigate(`${routerPath.messages}/${routerPath.messagesNew}`);
    }
  };

  if (sendMessagesCountInitial) {
    return null;
  }

  const count = MessagesCount?.CountChat + MessagesCount?.CountBroadCast;

  return (
    <div className="eb_header_messages_wrapper">
      <Badge
        id="GoToMessageButton"
        offset={[-10]}
        count={count}
        color="#EF3B3B"
      >
        <button
          className="eb_header_messages"
          onClick={gotoMessage}
          aria-label={`${trb(i18.Chat.BroadCast)} (${count})`}
        >
          <span aria-hidden="true">
            <IconLetter size={32} />
          </span>
        </button>
      </Badge>
    </div>
  );
};
